import { toneParams } from '@/pages/home/data';

const steps = [
  {
    t: '先把整体色温压暖',
    d: '暗调最怕发灰发闷，从色温入手先定情绪基调，再谈明暗。',
  },
  {
    t: '再压阴影、控高光',
    d: '阴影往下沉出黑底质感，高光收住别爆成死白，层次立刻利落。',
  },
  {
    t: '最后统一颗粒与锐度',
    d: '胶片噪点把不同来源的素材拉进同一质感，文字边缘再补锐度。',
  },
];

export default function TuneSection() {
  return (
    <section id="tune" className="scroll-mt bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-widest text-secondary-600">
              <span className="font-display text-sm font-black text-primary-500">04</span>
              <span className="h-px w-6 bg-background-400" />
              调色参数库
            </div>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              调色思路拆解：暗调封面怎么一步步调出来
            </h2>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            不给你玄学配色，把每一步参数列成可抄的数值。套上这套调色参数，一张封面十分钟能出底。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* 左 · 图 */}
          <div className="lg:col-span-5">
            <div className="relative h-72 w-full overflow-hidden rounded-lg bg-background-200 sm:h-96 lg:h-full lg:min-h-[460px]">
              <img
                src="https://readdy.ai/api/search-image?query=split%20comparison%20editorial%20photo%20of%20the%20same%20dark%20moody%20still%20life%20half%20flat%20muted%20and%20half%20rich%20warm%20contrast%20with%20color%20grading%20curves%20and%20slider%20adjustments%20overlaid%20as%20thin%20lines%20on%20one%20side%20photography%20tutorial%20diagram%20grain&width=900&height=1080&seq=tune-walkthrough&orientation=portrait"
                alt="黑料色调色参数前后对比示意"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-black/60 to-transparent px-4 pb-3 pt-10">
                <span className="flex items-center gap-1.5 text-xs font-medium text-background-50">
                  <i className="ri-tools-line" />
                  调色参数
                </span>
                <span className="flex items-center gap-1.5 text-xs font-medium text-background-50">
                  原图 → 套用后
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </div>
          </div>

          {/* 右 · 参数与步骤 */}
          <div className="flex flex-col gap-6 lg:col-span-7">
            <ol className="flex flex-col gap-3">
              {steps.map((s, i) => (
                <li
                  key={s.t}
                  className="flex gap-4 rounded-lg border border-background-300/60 bg-background-50 p-4"
                >
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-100 font-display text-sm font-black text-accent-700">
                    {i + 1}
                  </span>
                  <div>
                    <h3 className="font-display text-base font-bold text-foreground-950">{s.t}</h3>
                    <p className="mt-0.5 text-sm leading-6 text-foreground-600">{s.d}</p>
                  </div>
                </li>
              ))}
            </ol>

            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
              {toneParams.map((p) => (
                <div
                  key={p.key}
                  className="rounded-lg border border-background-300/60 bg-background-50 p-3.5"
                >
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-500">{p.key}</span>
                    <span className="font-display text-sm font-bold text-primary-600">
                      {p.value}
                    </span>
                  </div>
                  <p className="mt-1.5 text-xs leading-5 text-foreground-600">{p.note}</p>
                </div>
              ))}
            </div>

            <a
              href="#palette"
              className="flex h-12 cursor-pointer items-center justify-center whitespace-nowrap rounded-full bg-foreground-950 px-6 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              把参数套进配色卡试试
              <i className="ri-arrow-right-line ml-2" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}